document.addEventListener("DOMContentLoaded", () => {
    function initSearch() {
        const searchInput = document.querySelector(".js-search-input");
        const searchDropdown = document.getElementById("custom-search-popup");
        const recommendationsList = document.getElementById("custom-search-recommendations");
        const recommendationsTitle = document.getElementById("recommendations-title");
        const categoryList = document.getElementById("category-list");
        const searchHistoryList = document.getElementById("search-history-list");
        const clearHistoryButton = document.getElementById("clear-history");

        if (!searchInput || !searchDropdown || !recommendationsList || !recommendationsTitle || !categoryList || !searchHistoryList) {
            return;
       }

       document.addEventListener("click", (event) => {
    if (!searchDropdown.contains(event.target) && !searchInput.contains(event.target)) {
        searchDropdown.classList.remove("active");
        searchDropdown.style.display = "none";
        searchDropdown.style.visibility = "hidden";
        searchDropdown.style.opacity = "0";
    }
});

      
      
    function translateText() {
    const language = document.documentElement.lang || "en";
    const translations = {
        "en": {"recommendations": "Recommendations", "categories": "Categories", "searchHistory": "Search History", "clearHistory": "Clear History"},
        "fr": {"recommendations": "Recommandations", "categories": "Catégories", "searchHistory": "Historique de recherche", "clearHistory": "Effacer l'historique"},
        "nl": {"recommendations": "Aanbevelingen", "categories": "Categorieën", "searchHistory": "Zoekgeschiedenis", "clearHistory": "Geschiedenis wissen"},
        "ru": {"recommendations": "Рекомендации", "categories": "Категории", "searchHistory": "История поиска", "clearHistory": "Очистить историю"},
        "de": {"recommendations": "Empfehlungen", "categories": "Kategorien", "searchHistory": "Suchverlauf", "clearHistory": "Verlauf löschen"}
    };

    recommendationsTitle.textContent = translations[language]?.recommendations || translations["en"].recommendations;
    document.querySelector(".categories h3").textContent = translations[language]?.categories || translations["en"].categories;
    document.querySelector(".search-history h3").textContent = translations[language]?.searchHistory || translations["en"].searchHistory;

    const clearBtn = document.getElementById("clear-history");
    if (clearBtn) {
        clearBtn.textContent = {
            "en": "Clear all",
            "fr": "Tout effacer",
            "nl": "Alles wissen",
            "ru": "Очистить все",
            "de": "Alles löschen"
        }[language] || "Clear all";
    }
}


        function fetchCategories() {
            fetch('/collections.json')
                .then(response => response.json())
                .then(data => {
                    if (data.collections && data.collections.length > 0) {
                        const shuffledCategories = data.collections.sort(() => 0.5 - Math.random()).slice(0, 20);
                       const translationScript = document.getElementById("collection-translations");
const collectionTranslations = translationScript ? JSON.parse(translationScript.textContent) : {};

categoryList.innerHTML = shuffledCategories.map(col => {
    const localizedTitle = collectionTranslations[col.handle] || col.title;
    const currentLocale = document.documentElement.lang || 'en';
return `<li><a href="/${currentLocale}/collections/${col.handle}">${localizedTitle}</a></li>`;

}).join('');

                    }
                })
                .catch(() => {
                    categoryList.innerHTML = "<p>Ошибка загрузки категорий</p>";
                });
        }

        function saveSearchHistory(query) {
            if (!query.trim()) return;
            let history = JSON.parse(localStorage.getItem("searchHistory")) || [];
            if (!history.includes(query)) {
                history.unshift(query);
                if (history.length > 10) history.pop();
                localStorage.setItem("searchHistory", JSON.stringify(history));
            }
            updateSearchHistory();
        }

     function updateSearchHistory() {
    let history = JSON.parse(localStorage.getItem("searchHistory")) || [];

    searchHistoryList.innerHTML = history.slice(0, 6).map(item => {
        const trimmed = item.length > 18 ? item.slice(0, 15) + "..." : item;
        return `
            <li class="search-history-item" data-query="${item}">
                ${trimmed} <button class="delete-history" data-item="${item}">×</button>
            </li>
        `;
    }).join('');

    // Скрываем или показываем кнопку "Очистить историю"
    clearHistoryButton.style.display = history.length > 0 ? "block" : "none";
}


        function clearSearchHistory() {
            localStorage.removeItem("searchHistory");
            updateSearchHistory();
        }

    let cachedProducts = JSON.parse(localStorage.getItem("cachedProducts")) || []; // Храним последние товары

function fetchRandomRecommendations(container) {
    if (cachedProducts.length > 0) {
        displayProducts(container, cachedProducts);
    }

    fetch('/collections.json')
        .then(response => response.json())
        .then(data => {
            const collections = data.collections || [];
            const tryNext = (attempts = 5) => {
                if (attempts <= 0 || collections.length === 0) return;

                const random = collections.splice(Math.floor(Math.random() * collections.length), 1)[0];

                fetch(`/collections/${random.handle}/products.json`)
                    .then(res => {
                        if (!res.ok) throw new Error();
                        return res.json();
                    })
                    .then(data => {
                        if (data.products && data.products.length > 8) {
                            const newProducts = data.products.sort(() => 0.5 - Math.random()).slice(0, 8);
                            cachedProducts = newProducts;
                            localStorage.setItem("cachedProducts", JSON.stringify(newProducts));
                            updateProductsSmoothly(container, newProducts);
                        } else {
                            tryNext(attempts - 1);
                        }
                    })
                    .catch(() => {
                        tryNext(attempts - 1);
                    });
            };
            tryNext();
        })
        .catch(() => {});
}


// Функция отображения товаров
function displayProducts(container, products) {
    const currentLocale = window.Shopify?.locale || document.documentElement.lang || 'en';

    container.innerHTML = products.map(product => `
        <li class="recommendation-item fade-in">
            <a href="/${currentLocale}/products/${product.handle}" class="recommendation-link">
                <img src="${product.images[0]?.src || 'https://via.placeholder.com/50'}" alt="${product.title}" />
                <span>${product.title.length > 15 ? product.title.slice(0, 15) + "..." : product.title}</span>
            </a>
        </li>
    `).join('');
}


// Плавное обновление товаров
function updateProductsSmoothly(container, newProducts) {
    container.classList.add("fade-out"); // Добавляем анимацию исчезновения
    setTimeout(() => {
        displayProducts(container, newProducts);
        container.classList.remove("fade-out"); // Убираем анимацию после замены
    }, 500); // Ждём 0.5 секунды перед заменой
}

// Стили для плавной анимации (добавь в CSS)
const styles = `
.recommendation-item.fade-in {
    opacity: 0;
    animation: fadeIn 0.5s forwards;
}

.fade-out {
    opacity: 0;
    transition: opacity 0.5s;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
`;
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);





  searchInput.addEventListener("focus", () => {
    const predictiveSearch = document.querySelector(".predictive-search");
    const isMainSearchVisible = predictiveSearch &&
        window.getComputedStyle(predictiveSearch).visibility !== "hidden" &&
        window.getComputedStyle(predictiveSearch).display !== "none" &&
        window.getComputedStyle(predictiveSearch).opacity !== "0";

    if (isMainSearchVisible) return; // если фиолетовый открыт — не показываем белое

    searchDropdown.classList.add("active");
    searchDropdown.style.display = "";
    searchDropdown.style.visibility = "visible";
    searchDropdown.style.opacity = "1";

    translateText();
    fetchCategories();
    fetchRandomRecommendations(recommendationsList);
    updateSearchHistory();
});



        searchInput.addEventListener("keydown", (event) => {
            if (event.key === "Enter") {
                saveSearchHistory(searchInput.value);
                searchDropdown.classList.remove("active");
                searchDropdown.style.display = "none";
                searchDropdown.style.visibility = "hidden";
                searchDropdown.style.opacity = "0";
            }
        });

        searchInput.addEventListener("input", () => {
            searchDropdown.classList.remove("active");
            searchDropdown.style.display = "none";
            searchDropdown.style.visibility = "hidden";
            searchDropdown.style.opacity = "0";
        });

       searchHistoryList.addEventListener("click", (event) => {
    if (event.target.classList.contains("delete-history")) {
        event.stopPropagation(); // <--- ВАЖНО: предотвращаем закрытие окна
        const itemToRemove = event.target.dataset.item;
        let history = JSON.parse(localStorage.getItem("searchHistory")) || [];
        history = history.filter(item => item !== itemToRemove);
        localStorage.setItem("searchHistory", JSON.stringify(history));
        updateSearchHistory();
    } else if (event.target.classList.contains("search-history-item")) {
        searchInput.value = event.target.dataset.query;
        searchInput.focus();
        // Закрываем окно — это ОК при выборе из истории
        searchDropdown.classList.remove("active");
        searchDropdown.style.display = "none";
        searchDropdown.style.visibility = "hidden";
        searchDropdown.style.opacity = "0";
    }
});


        clearHistoryButton.addEventListener("click", clearSearchHistory);
    }
  initSearch();


});
